/**
 * Step configuration for dynamic step management
 */

import {RmcOrderIntakeStepType} from './stepTypes'

// Re-export for convenience
export {RmcOrderIntakeStepType}

/**
 * Configuration for step appearance and behavior
 */
export type StepConfig = {
  name: RmcOrderIntakeStepType
  isEnabled: boolean
  component: string // Reference to existing step component
  fields?: string[] // Fields that should be shown in this step
  order: number
}

/**
 * Type for step ordering configuration
 */
export type StepOrderingConfig = Record<RmcOrderIntakeStepType, number>

/**
 * Default step order configuration
 */
export const DEFAULT_STEP_ORDER: StepOrderingConfig = {
  [RmcOrderIntakeStepType.QUOTE]: 0,
  [RmcOrderIntakeStepType.MATERIAL]: 1,
  [RmcOrderIntakeStepType.MIX_CHARACTERISTICS]: 2,
  [RmcOrderIntakeStepType.QUANTITY]: 3,
  [RmcOrderIntakeStepType.USAGE]: 4,
  [RmcOrderIntakeStepType.UNLOADING_METHOD]: 5,
  [RmcOrderIntakeStepType.INTERVALS]: 6,
  [RmcOrderIntakeStepType.DATE]: 7,
  [RmcOrderIntakeStepType.TIME]: 8,
  [RmcOrderIntakeStepType.DETAILS]: 9
}
